// api/reschedulings.js
// 授業振替に関するAPIを実装する

import Api from './api_base'

export default {
  // GET /reschedulings 全ての授業振替情報を取得する
  get: () => {
    return Api.get('/reschedulings')
    .catch((err) => {
      console.log(err)
    })
  },
  // GET /reschedulings/{hash} 指定されたハッシュ値の授業振替情報を取得する
  getByHash: (hash) => {
    return Api.get('/reschedulings/' + hash)
    .catch((err) => {
      console.log(err)
    })
  },
  getList: (id) => {
    return Api.get('reservationslist/' + id)
    .catch((err) => {
      console.log(err)
    })
  },
  // POST /reschedulings 授業振替情報を登録する
  post: (params) => {
    return Api.post('/reschedulings', params)
  },
  // PUT /reschedulings/{hash} 授業振替情報を更新する
  put: (hash, params) => {
    return Api.put('/reschedulings/' + hash, params)
  }
}



// WEBPACK FOOTER //
// ./src/api/reschedulings.js